/* custom-wishlist.js */
document.addEventListener('DOMContentLoaded', () => {
  const LOCAL_STORAGE_KEY = 'touch925_wishlist_items';

  function getWishlist() {
    try {
      const items = localStorage.getItem(LOCAL_STORAGE_KEY);
      return items ? JSON.parse(items) : [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(items) {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(items));
    renderWishlistCount();
    updateUIStates();
    renderDrawer();
  }

  function formatMoney(cents) {
    return '₹ ' + (cents / 100).toFixed(2);
  }

  async function addToWishlist(handle) {
    let items = getWishlist();
    if (items.some(item => item.handle === handle)) return;

    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) throw new Error('Product not found');
      
      const product = await response.json();
      const variant = product.variants[0];
      
      const wishlistItem = {
        handle: handle,
        id: product.id,
        variantId: variant.id,
        title: product.title,
        price: variant.price,
        compareAtPrice: variant.compare_at_price,
        image: product.featured_image,
        url: product.url
      };

      items.push(wishlistItem);
      setWishlist(items);
    } catch (err) {
      console.error("Error adding to wishlist:", err);
    }
  }

  function removeFromWishlist(handle) {
    let items = getWishlist();
    items = items.filter(item => item.handle !== handle);
    setWishlist(items);
  }

  function toggleWishlist(handle) {
    const items = getWishlist();
    if (items.some(item => item.handle === handle)) {
      removeFromWishlist(handle);
    } else {
      addToWishlist(handle);
    }
  }

  function renderWishlistCount() {
    const items = getWishlist();
    document.querySelectorAll('.custom-wishlist-counter').forEach(el => {
      el.textContent = items.length;
      if (items.length > 0) {
        el.style.display = 'inline-flex';
      } else {
        el.style.display = 'none';
      }
    });
  }

  function updateUIStates() {
    const items = getWishlist();
    const handles = items.map(item => item.handle);

    document.querySelectorAll('.custom-wishlist-btn-product').forEach(btn => {
      const handle = btn.getAttribute('data-product-handle');
      if (handles.includes(handle)) {
        btn.classList.add('active');
        btn.title = "Remove from Wishlist";
      } else {
        btn.classList.remove('active');
        btn.title = "Add to Wishlist";
      }
    });
  }

  function renderDrawer() {
    const container = document.querySelector('.custom-wishlist-items-container');
    if (!container) return;

    const items = getWishlist();
    
    if (items.length === 0) {
      container.innerHTML = `
        <div class="custom-wishlist-empty-state">
          <svg class="icon--root icon--heart" xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 256 256">
            <path d="M178 42c-21 0-39.26 9.47-50 25.34C117.26 51.47 99 42 78 42a60.07 60.07 0 0 0-60 60c0 29.2 18.2 59.59 54.1 90.31a334.68 334.68 0 0 0 53.06 37 a6 6 0 0 0 5.68 0 334.68 334.68 0 0 0 53.06-37C219.8 161.59 238 131.2 238 102a60.07 60.07 0 0 0-60-60Zm-50 175.11c-16.41-9.47-98-59.39-98-115.11a48.05 48.05 0 0 1 48-48c20.28 0 37.31 10.83 44.45 28.27a6 6 0 0 0 11.1 0C140.69 64.83 157.72 54 178 54a48.05 48.05 0 0 1 48 48c0 55.72-81.59 105.64-98 115.11Z" />
          </svg>
          <p style="margin-top:20px;font-size:16px;">Your wishlist is currently empty.</p>
          <a href="/collections/all" class="custom-wishlist-btn-shop" style="color:#fff">Shop Now</a>
        </div>
      `;
      return;
    }

    let html = '';
    items.forEach(item => {
      const imgUrl = item.image ? item.image : '//cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bab9c0c16cb99f1fa1aa4d2defaedcf47e852a4e23cfdc44.gif';
      html += `
        <div class="custom-wishlist-item" data-handle="${item.handle}">
          <a href="${item.url}"><img src="${imgUrl}" class="custom-wishlist-item-image" alt="Product Image"></a>
          <div class="custom-wishlist-item-details">
            <a href="${item.url}" class="custom-wishlist-item-title">${item.title}</a>
            <div class="custom-wishlist-item-price">
              ${item.compareAtPrice && item.compareAtPrice > item.price ? `<s style="color: #999; font-weight: normal; margin-right: 5px; font-size: 12px;">${formatMoney(item.compareAtPrice)}</s>` : ''}${formatMoney(item.price)}
            </div>
            <div class="custom-wishlist-item-actions">
              <button class="custom-wishlist-btn-add-to-cart" data-variant-id="${item.variantId}" data-handle="${item.handle}">Add To Cart</button>
              <button class="custom-wishlist-btn-remove" data-handle="${item.handle}" title="Remove">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
              </button>
            </div>
          </div>
        </div>
      `;
    });

    container.innerHTML = html;
  }

  // Event delegation for clicks
  document.addEventListener('click', (e) => {
    // Drawer Enforcer
    const openTrigger = e.target.closest('[data-drawer-open="right"]');
    if (openTrigger) {
      const targetView = openTrigger.getAttribute('data-drawer-view');
      setTimeout(() => {
        document.querySelectorAll('.drawer--side[data-side="right"] .drawer--container').forEach(el => {
          if (el.getAttribute('data-view') === targetView) {
            el.classList.add('is-active-wishlist-override');
          } else {
            el.classList.remove('is-active-wishlist-override');
          }
        });
      }, 50);
    }
    
    // Toggle from product cards
    const btn = e.target.closest('.custom-wishlist-btn-product');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      const handle = btn.getAttribute('data-product-handle');
      if (handle) toggleWishlist(handle);
    }

    // Remove from drawer
    const removeBtn = e.target.closest('.custom-wishlist-btn-remove');
    if (removeBtn) {
      const handle = removeBtn.getAttribute('data-handle');
      if (handle) removeFromWishlist(handle);
    }

    // Add to cart from drawer
    const addCartBtn = e.target.closest('.custom-wishlist-btn-add-to-cart');
    if (addCartBtn) {
      const variantId = addCartBtn.getAttribute('data-variant-id');
      const handle = addCartBtn.getAttribute('data-handle');
      
      if (variantId) {
        addCartBtn.textContent = 'Adding...';
        addCartBtn.disabled = true;

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
        .then(res => {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(data => {
          removeFromWishlist(handle);
          window.location.reload();
        })
        .catch(err => {
          console.error(err);
          addCartBtn.textContent = 'Error';
          addCartBtn.disabled = false;
        });
      }
    }
  }, true);

  // Init
  renderWishlistCount();
  updateUIStates();
  renderDrawer();
  
  // Create an observer to re-run updateUIStates when new product cards are added.
  // Debounced because third-party app scripts on this store mutate the DOM
  // frequently; without batching this would re-run the full scan on every
  // single mutation and hurt input responsiveness (INP).
  let updateUIStatesTimer = null;
  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;
    for (let mutation of mutations) {
      if (mutation.addedNodes.length) shouldUpdate = true;
    }
    if (shouldUpdate) {
      clearTimeout(updateUIStatesTimer);
      updateUIStatesTimer = setTimeout(updateUIStates, 100);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
